
import { AssetType } from '../../assettype/model/asset-type.model';
import { MAINTENANCE_ASPECT_METADATA } from './maintenance-aspect.metadata';
import { MaintenanceAspectBase } from './maintenance-aspect.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface MaintenanceAspect extends MaintenanceAspectBase {
}

export interface MaintenanceAspectTransient { }

export class MaintenanceAspect extends CrudEntity<MaintenanceAspect, number, MaintenanceAspectTransient> implements MaintenanceAspectTransient {
  constructor(source?: Partial<MaintenanceAspect>, options?: CrudEntityConstructionOptions<MaintenanceAspect, number, MaintenanceAspectTransient>) {
    super(MAINTENANCE_ASPECT_METADATA, source, options);
  }

  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }

  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }

  setDefaultsForAssetType(assetType: AssetType) {
    if (assetType != null) {
      this.maintenanceType = assetType.maintenanceType;
      this.visualInspection = assetType.visualInspection;
      this.periodicMaintenance = assetType.periodicMaintenance;
      this.periodicMaintenanceDays = assetType.periodicMaintenanceDays;
      this.routineMaintenance = assetType.routineMaintenance;
      this.routineMaintenanceDays = assetType.routineMaintenanceDays;
    }
  }

  get aspectAssetId() {
    return null;
  }
}





